import axios from "../http";
import { BASE } from "../index";
const BASE_URL = process.env.VUE_APP_GENERAL_URL;
const base = BASE.EXPORT_CENTER;

/**
 * 大客户余额退还 校验信息
 * @param {*} params
 * @returns
 */
export function rechargeReturncheckMobile(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/rechargeReturn/checkMobile`,
    data: params,
  });
}
/**
 * 大客户余额退还-信息提交
 * @param {*} params
 * @returns
 */
export function rechargeReturnsave(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/rechargeReturn/save`,
    data: params,
  });
}
/**
 * 大客户余额返还 审核
 * @param {*} params
 * @returns
 */
export function rechargeReturnaudit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/rechargeReturn/audit`,
    data: params,
  });
}
/**
 * 总控-基础设置-会员充值列表（带分页）
 * @param {*} params
 * @returns
 */
export function getMemberTopUpList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/vip/discount/grade/list`,
    data: params,
  });
}

/**
 * 总控-基础设置-会员充值列表（下拉选择项，不带分页）
 * @param {*} params
 * @returns
 */
export function getMemberTopUpSelectList(params = {}) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/vip/discount/grade/select`,
    params,
  });
}

/**
 * 总控-基础设置-会员充值-编辑
 * @param {*} params
 * @returns
 */
export function postMemberTopUpEdit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/vip/discount/grade/save`,
    data: params,
  });
}

/**
 * 总控-会员管理-会员充值记录
 * @param {*} params
 * @returns
 */
export function getMemberTopUpLog(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/memberRecharge/list`,
    data: params,
  });
}

/**
 * 总控-会员管理-会员充值记录-验证手机号是否是会员
 * @param {*} params
 * @returns
 */
export function getValidMobileForMember(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/member/mobile/check`,
    params,
  });
}

/**
 * 总控-会员管理-会员充值记录-新增
 * @param {*} params
 * @returns
 */
export function postMemberTopUpCreate(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/memberRecharge/save`,
    params,
  });
}

/**
 * 总控-会员管理-会员充值记录-额度转移-额度查询
 * @param {*} params
 * @returns
 */
export function getMemberBalance(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/memberRecharge/getMemberBalance`,
    data: params,
  });
}

/**
 * 总控-会员管理-会员充值记录-额度转移-额度新增
 * @param {*} params
 * @returns
 */
export function postMemberAddMoveMoney(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/memberRecharge/setPurchaseCoinTransfer`,
    data: params,
  });
}

/**
 * 总控-会员管理-会员充值记录-审核到账
 * @param {*} params
 * @returns
 */
export function postAuditForMember(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/memberRecharge/approval`,
    params,
  });
}

/**
 * 总控-会员管理-会员充值记录-消费明细
 * @param {*} params
 * @returns
 */
export function getDeductionDetailOfMember(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/vip/consume/detail/list`,
    params,
  });
}

/**
 * 总控-会员管理-全部城市仓
 * @param {*} params
 * @returns
 */
export function getAllLogisticsList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/logistics/all/list`,
    data: params,
  });
}

/**
 * 总控-会员管理-消费明细列表
 * @param {*} params
 * @returns
 */
export function postLogisticsList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/vip/consume/logistics/list`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公客户充值记录-列表
 * @param {*} params
 * @returns
 */
export function getCorporateRechargeList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/recharge/list`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公客户充值记录-审核/作废
 * @param {*} params
 * @returns
 */
export function postCorporateRechargeAudit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/recharge/audit`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公客户充值记录-新增-手机号校验
 * @param {*} params
 * @returns
 */
export function postCorporateRechargeCheckMobile(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/recharge/checkMobile`,
    data: params,
  });
}
/**
 * 总控-会员管理-对公客户充值记录-新增-手机号校验
 * @param {*} params
 * @returns
 */
export function posttdcOwnerRechargeCheckMobile(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/tdcOwner/recharge/checkMobile`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公客户充值记录-新增
 * @param {*} params
 * @returns
 */
export function postCorporateRechargeSave(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/recharge/save`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公客户充值记录-导出
 * @param {*} params
 * @returns
 */
export function postCorporateRechargeExport(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/corporate/recharge/export`,
    responseType: "blob",
    data: params,
  });
}

/**
 * 总控-会员管理-对公消费记录-列表
 * @param {*} params
 * @returns
 */
export function postMemberGetCustomerExpenseRecord(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/member/getCustomerExpenseRecord`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公消费记录-对公 缺货/退款详情
 * @param {*} params
 * @returns
 */
export function postMemberGetCustomerRefundInfo(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/member/getCustomerRefundInfo`,
    data: params,
  });
}
/**
 * 总控-会员管理-城市仓充值审核
 * @param {*} params
 * @returns
 */
export function posttdcOwnerrechargesetAudit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/tdcOwner/recharge/setAudit`,
    data: params,
  });
}

/**
 * 总控-会员管理-对公消费记录导出
 * @param {*} params
 * @returns
 */
export function postMembergetCustomerExpenseRecordeExport(params = {}) {
  return axios({
    method: "POST",
    url: `${base}/bi/member/getCustomerExpenseRecord/export`,
    data: params,
  });
}
